import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import type { FAQItem } from '../types';
import { getInterviewBookingContact } from '../../../utils/contactHelpers';

interface FAQSectionProps {
  faqs: FAQItem[];
}

const FAQSection = ({ faqs }: FAQSectionProps) => {
  const [openId, setOpenId] = useState<string | null>(faqs[0].id);

  const toggleFAQ = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  const handleContactClick = getInterviewBookingContact();

  return (
    <section id="faq" className="py-20 sm:py-32 bg-gradient-to-br from-accent/5 to-primary/5">
      <div className="max-w-content mx-auto px-4 sm:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-6">
            Часто задаваемые вопросы
          </h2>
          <p className="text-lg text-secondary max-w-3xl mx-auto">
            Ответы на самые популярные вопросы о нашем сервисе
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className="bg-card rounded-xl border border-border overflow-hidden transition-all duration-300 hover:shadow-lg"
            >
              <button
                onClick={() => toggleFAQ(faq.id)}
                className="w-full px-6 py-5 flex items-center justify-between gap-4 text-left hover:bg-muted transition-colors duration-200"
              >
                <span className="text-lg font-semibold text-foreground">{faq.question}</span>
                <Icon
                  name={openId === faq.id ? 'ChevronUp' : 'ChevronDown'}
                  size={24}
                  className="flex-shrink-0 transition-transform duration-200"
                />
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openId === faq.id ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-5 text-secondary leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-secondary mb-4">Не нашли ответ на свой вопрос?</p>
          <button
            onClick={handleContactClick}
            className="inline-flex items-center gap-2 text-primary font-semibold hover:underline cursor-pointer"
          >
            Свяжитесь с нами
            <Icon name="ArrowRight" size={20} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;